module.exports = __webpack_public_path__ + "img/blues-logo.f0f3e51a.svg";